import { formatMinorAmount } from "@/constants/billingCatalog";
import { formatCatalogAmount } from "@/lib/landingCatalogCopy";

export const FAQ_STAMP = "OBJECTION CLEARANCE";

export const FAQ_SCAN_PILLS = [
  { value: "NO", label: "CRM change" },
  { value: "NO", label: "Staff cuts" },
  { value: "—", label: "Per month" },
  { value: "24/7", label: "Emergencies" },
  { value: "1-CLICK", label: "Override" },
];

export const FAQ_HEADLINE = {
  lead: "Common",
  accent: "Questions",
};

export const FAQ_SCAN_LINE = "Five objections roofers ask — answered in one glance";

export const FAQ_ITEMS = [
  {
    id: "crm",
    index: "01",
    verdict: "NO",
    verdictTone: "neutral",
    question: "Do we need to change our CRM?",
    answer:
      "No. The Roofing Interceptor integrates into your existing workflow within 72 hours. Your team keeps the same tools — the digital employee qualifies, logs, and books in the background.",
  },
  {
    id: "staff",
    index: "02",
    verdict: "NO",
    verdictTone: "neutral",
    question: "Will this replace our office staff?",
    answer:
      "No. It's a digital employee for your team, not a replacement. It handles greet, qualify, log, and book — so your people focus on vetted, calendar-ready prospects.",
  },
  {
    id: "emergency",
    index: "03",
    verdict: "24/7",
    verdictTone: "hero",
    question: "What about storm damage and emergency leaks?",
    answer:
      "Built for high-intent inbound: leak emergencies, storm reports, and free inspection requests are intercepted around the clock — including nights and weekends.",
  },
  {
    id: "cost",
    index: "04",
    verdict: "—",
    verdictTone: "hero",
    question: "What does it cost after the trial?",
    answer:
      "14-day free trial, no credit card required. After trial: billed monthly when you continue. Standard Plug&Play setup; custom CRM integrations scoped at kickoff if needed.",
  },
  {
    id: "control",
    index: "05",
    verdict: "1-CLICK",
    verdictTone: "teal",
    question: "What if the AI gets something wrong?",
    answer:
      "Instant alerts, a direct dashboard link, and 1-click manual takeover for any chat. Pricing, services, and service-area guardrails are hard-coded to your policies.",
  },
];

export function faqScanPillsForOffer(entryOffer) {
  return FAQ_SCAN_PILLS.map((pill) => {
    if (pill.label !== "Per month") return pill;
    return {
      ...pill,
      value: entryOffer
        ? formatCatalogAmount(entryOffer.amount_minor, entryOffer.currency)
        : "—",
    };
  });
}

export function faqItemsForOffer(entryOffer) {
  return FAQ_ITEMS.map((item) => {
    if (item.id !== "cost") return item;
    if (entryOffer) {
      return {
        ...item,
        verdict: formatCatalogAmount(entryOffer.amount_minor, entryOffer.currency),
        answer: `14-day free trial, no credit card required. After trial: ${formatMinorAmount(entryOffer.amount_minor, entryOffer.currency)}. Standard Plug&Play setup; custom CRM integrations scoped at kickoff if needed.`,
      };
    }
    return {
      ...item,
      verdict: "—",
      answer:
        "14-day free trial, no credit card required. After trial: billed monthly when you continue. Standard Plug&Play setup; custom CRM integrations scoped at kickoff if needed.",
    };
  });
}
